import { createApp } from 'vue'
import axios from 'axios'

import router from '@/routes/index.js'
import App from './App.vue'

import '@/assets/theme.css'

// useAuth and useApi both read this, so it has to be set before the app mounts.
axios.defaults.baseURL =
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_API_URL ||
    'http://localhost:3000/api/v1'

export const app = createApp(App)

app.use(router)
app.mount('#app')
